export class WorkflowApproval {
public id: number;
public name:string;
public employee_id:string;
public description: string;  
public created_dt : Date;
public created_by :string;
public update_dt : Date;
public updated_by :string;
public approvalId:string;

constructor(){
    this.id =null;
    this.name = null;
    this.employee_id ='';
    this.description = null;
    this.created_dt = null;
    this.created_by = '';
    this.update_dt =null;
    this.updated_by = '';
    this.approvalId = '';

}
}
